import * as React from 'react';
import { Image } from '@cian/ui-kit';
import * as styles from './ResponsiveImage.css';

// Соотношение 16:9
const aspectRatioDefault = 0.56;

interface IResponsiveImageProps {
  src: string;
  alt?: string;
  aspectRatio?: number;
}

export const ResponsiveImage: React.FC<IResponsiveImageProps> = ({ src, alt, aspectRatio = aspectRatioDefault }) => {
  const paddingBottom = Math.round(aspectRatio * 100) + '%';

  return (
    <div className={styles['container']} style={{ paddingBottom }}>
      <div className={styles['image-wrapper']}>
        <Image width="100%" height="100%" objectFit="cover" src={src} alt={alt} />
      </div>
    </div>
  );
};
